var map = {
	"./baihe.png": "./src/assets/shiwu/baihe.png",
	"./baijiu.png": "./src/assets/shiwu/baijiu.png",
	"./bailuobo.png": "./src/assets/shiwu/bailuobo.png",
	"./baimizhou.png": "./src/assets/shiwu/baimizhou.png",
	"./banli.png": "./src/assets/shiwu/banli.png",
	"./bocai.png": "./src/assets/shiwu/bocai.png",
	"./bohe.png": "./src/assets/shiwu/bohe.png",
	"./boluo.png": "./src/assets/shiwu/boluo.png",
	"./chengzi.png": "./src/assets/shiwu/chengzi.png",
	"./chenpi.png": "./src/assets/shiwu/chenpi.png",
	"./chenpicha.png": "./src/assets/shiwu/chenpicha.png",
	"./chixiaodou.png": "./src/assets/shiwu/chixiaodou.png",
	"./cu.png": "./src/assets/shiwu/cu.png",
	"./dasuan.png": "./src/assets/shiwu/dasuan.png",
	"./donggua.png": "./src/assets/shiwu/donggua.png",
	"./doufu.png": "./src/assets/shiwu/doufu.png",
	"./doujiang.png": "./src/assets/shiwu/doujiang.png",
	"./feirou.png": "./src/assets/shiwu/feirou.png",
	"./fengmi.png": "./src/assets/shiwu/fengmi.png",
	"./fengwangjiang.png": "./src/assets/shiwu/fengwangjiang.png",
	"./foshou.png": "./src/assets/shiwu/foshou.png",
	"./ganju.png": "./src/assets/shiwu/ganju.png",
	"./gaotanglingshi.png": "./src/assets/shiwu/gaotanglingshi.png",
	"./gerou.png": "./src/assets/shiwu/gerou.png",
	"./gongbaojiding.png": "./src/assets/shiwu/gongbaojiding.png",
	"./guazi.png": "./src/assets/shiwu/guazi.png",
	"./guiyuan.png": "./src/assets/shiwu/guiyuan.png",
	"./hetao.png": "./src/assets/shiwu/hetao.png",
	"./hongjiu.png": "./src/assets/shiwu/hongjiu.png",
	"./hongzao.png": "./src/assets/shiwu/hongzao.png",
	"./huajiao.png": "./src/assets/shiwu/huajiao.png",
	"./huajuan.png": "./src/assets/shiwu/huajuan.png",
	"./huanggua.png": "./src/assets/shiwu/huanggua.png",
	"./huangjiu.png": "./src/assets/shiwu/huangjiu.png",
	"./huasheng.png": "./src/assets/shiwu/huasheng.png",
	"./hujiao.png": "./src/assets/shiwu/hujiao.png",
	"./jidan.png": "./src/assets/shiwu/jidan.png",
	"./jirou.png": "./src/assets/shiwu/jirou.png",
	"./jiucai.png": "./src/assets/shiwu/jiucai.png",
	"./kafei.png": "./src/assets/shiwu/kafei.png",
	"./kaojichi.png": "./src/assets/shiwu/kaojichi.png",
	"./kongxincai.png": "./src/assets/shiwu/kongxincai.png",
	"./kugua.png": "./src/assets/shiwu/kugua.png",
	"./lajiao.png": "./src/assets/shiwu/lajiao.png",
	"./lengdongshipin.png": "./src/assets/shiwu/lengdongshipin.png",
	"./lengyin.png": "./src/assets/shiwu/lengyin.png",
	"./li.png": "./src/assets/shiwu/li.png",
	"./liulian.png": "./src/assets/shiwu/liulian.png",
	"./lizhi.png": "./src/assets/shiwu/lizhi.png",
	"./longyan.png": "./src/assets/shiwu/longyan.png",
	"./lvcha.png": "./src/assets/shiwu/lvcha.png",
	"./lvdou.png": "./src/assets/shiwu/lvdou.png",
	"./mangguo.png": "./src/assets/shiwu/mangguo.png",
	"./mantou.png": "./src/assets/shiwu/mantou.png",
	"./meiguihua.png": "./src/assets/shiwu/meiguihua.png",
	"./meiguihuacha.png": "./src/assets/shiwu/meiguihuacha.png",
	"./miantiao.png": "./src/assets/shiwu/miantiao.png",
	"./mifan.png": "./src/assets/shiwu/mifan.png",
	"./mihoutao.png": "./src/assets/shiwu/mihoutao.png",
	"./muer.png": "./src/assets/shiwu/muer.png",
	"./naicha.png": "./src/assets/shiwu/naicha.png",
	"./nailao.png": "./src/assets/shiwu/nailao.png",
	"./naiyou.png": "./src/assets/shiwu/naiyou.png",
	"./nangua.png": "./src/assets/shiwu/nangua.png",
	"./niunai.png": "./src/assets/shiwu/niunai.png",
	"./niurou.png": "./src/assets/shiwu/niurou.png",
	"./nongcha.png": "./src/assets/shiwu/nongcha.png",
	"./nuomi.png": "./src/assets/shiwu/nuomi.png",
	"./paigu.png": "./src/assets/shiwu/paigu.png",
	"./pangxie.png": "./src/assets/shiwu/pangxie.png",
	"./pijiu.png": "./src/assets/shiwu/pijiu.png",
	"./pingguo.png": "./src/assets/shiwu/pingguo.png",
	"./putao.png": "./src/assets/shiwu/putao.png",
	"./qincai.png": "./src/assets/shiwu/qincai.png",
	"./shanyao.png": "./src/assets/shiwu/shanyao.png",
	"./shanzha.png": "./src/assets/shiwu/shanzha.png",
	"./shaokao.png": "./src/assets/shiwu/shaokao.png",
	"./shengcai.png": "./src/assets/shiwu/shengcai.png",
	"./shengjiang.png": "./src/assets/shiwu/shengjiang.png",
	"./shengluobo.png": "./src/assets/shiwu/shengluobo.png",
	"./shizi.png": "./src/assets/shiwu/shizi.png",
	"./shuizhuniurou.png": "./src/assets/shiwu/shuizhuniurou.png",
	"./tangyuan.png": "./src/assets/shiwu/tangyuan.png",
	"./tansuanyinliao.png": "./src/assets/shiwu/tansuanyinliao.png",
	"./taozi.png": "./src/assets/shiwu/taozi.png",
	"./tiandian.png": "./src/assets/shiwu/tiandian.png",
	"./tudou.png": "./src/assets/shiwu/tudou.png",
	"./xia.png": "./src/assets/shiwu/xia.png",
	"./xiangjiao.png": "./src/assets/shiwu/xiangjiao.png",
	"./xiaohuixiang.png": "./src/assets/shiwu/xiaohuixiang.png",
	"./xiaomi.png": "./src/assets/shiwu/xiaomi.png",
	"./xigua.png": "./src/assets/shiwu/xigua.png",
	"./xihongshi.png": "./src/assets/shiwu/xihongshi.png",
	"./xilanhua.png": "./src/assets/shiwu/xilanhua.png",
	"./yangcong.png": "./src/assets/shiwu/yangcong.png",
	"./yangrou.png": "./src/assets/shiwu/yangrou.png",
	"./yarou.png": "./src/assets/shiwu/yarou.png",
	"./yimi.png": "./src/assets/shiwu/yimi.png",
	"./yiner.png": "./src/assets/shiwu/yiner.png",
	"./youyu.png": "./src/assets/shiwu/youyu.png",
	"./youzhashipin.png": "./src/assets/shiwu/youzhashipin.png",
	"./youzi.png": "./src/assets/shiwu/youzi.png",
	"./yumi.png": "./src/assets/shiwu/yumi.png",
	"./yurou.png": "./src/assets/shiwu/yurou.png",
	"./zhima.png": "./src/assets/shiwu/zhima.png",
	"./zicai.png": "./src/assets/shiwu/zicai.png",
	"./zongzi.png": "./src/assets/shiwu/zongzi.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/shiwu sync recursive ^\\.\\/.*\\.png$";